import { useActiveProject } from "@/features/project/ActiveProject";
import { updateProject } from "@repo/api";
import {
  type ClassificationDefinition,
  type UpdateOpportunity,
} from "@repo/api";
import { Button } from "@repo/skapa";
import { t } from "@repo/translation";
import { useToast } from "@repo/ui";
import { ModalSheet } from "@repo/ui";
import { useState } from "react";

import { ClassificationSelections } from "./ClassificationSelections";
import { type ClassificationState } from "./types.ts";

interface ClassificationModalProps {
  isOpen: boolean;
  closeModal: () => void;
  classification: ClassificationDefinition;
}

const Footer = ({
  update,
  disabled,
}: {
  update: () => void;
  disabled?: boolean;
}) => (
  <Button
    text={t("action.save")}
    disabled={disabled}
    onClick={update}
    type="primary"
  />
);

export const ClassificationModal = ({
  isOpen,
  closeModal,
  classification,
}: ClassificationModalProps) => {
  const [newClassification, setNewClassification] =
    useState<ClassificationState>({ classification });
  const { updateToast } = useToast();
  const { opportunity } = useActiveProject();

  const update = (newOpportunity: UpdateOpportunity) => {
    updateProject(newOpportunity, updateToast).then(() => {
      closeModal();
    });
  };

  return (
    <ModalSheet
      title={t("label.classification")}
      visible={isOpen}
      onClose={closeModal}
      onBack={closeModal}
      footer={
        <Footer
          disabled={newClassification.reason === undefined}
          update={() => {
            if (opportunity) {
              update({
                id: opportunity?.id,
                classification: newClassification.classification,
                classificationChangeDetails: {
                  description: newClassification.description,
                  reason: newClassification.reason,
                },
              });
            }
          }}
        />
      }
    >
      <ClassificationSelections
        state={newClassification}
        setState={setNewClassification}
      />
    </ModalSheet>
  );
};
